const SAST_TIMEZONE = 'Africa/Johannesburg';
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const bucketFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: SAST_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  hour12: false,
  weekday: 'short',
});

function partValue(parts, type) {
  return parts.find((part) => part.type === type)?.value;
}

export function isPlausibleDate(iso) {
  if (!iso) return false;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return false;
  return date.getUTCFullYear() >= 2000;
}

export function firstPlausibleDate(...candidates) {
  for (const iso of candidates) {
    if (isPlausibleDate(iso)) return iso;
  }
  return null;
}

export function addDaysToDateKey(dateKey, days) {
  const [year, month, day] = dateKey.split('-').map(Number);
  const utc = new Date(Date.UTC(year, month - 1, day + days));
  return [
    utc.getUTCFullYear(),
    String(utc.getUTCMonth() + 1).padStart(2, '0'),
    String(utc.getUTCDate()).padStart(2, '0'),
  ].join('-');
}

export function sastBucket(iso) {
  const parts = bucketFormatter.formatToParts(new Date(iso));
  const year = partValue(parts, 'year');
  const month = String(partValue(parts, 'month') || '').padStart(2, '0');
  const day = String(partValue(parts, 'day') || '').padStart(2, '0');
  const hour = parseInt(partValue(parts, 'hour'), 10) % 24;
  const weekday = partValue(parts, 'weekday');
  const dateKey = `${year}-${month}-${day}`;
  const dayOfWeek = WEEKDAYS.indexOf(weekday);
  const weekStartKey = addDaysToDateKey(dateKey, -(dayOfWeek >= 0 ? dayOfWeek : 0));

  return {
    dateKey,
    hour: Number.isFinite(hour) ? hour : 0,
    dayOfWeek: dayOfWeek >= 0 ? dayOfWeek : 0,
    weekStartKey,
  };
}

export function formatSastDateKey(dateKey) {
  if (!dateKey || typeof dateKey !== 'string') return 'Invalid';
  const [year, month, day] = dateKey.split('-');
  if (!year || !month || !day) return dateKey;
  return `${day}/${month}/${year}`;
}

export function formatSastWeekRange(weekStartKey) {
  const weekEndKey = addDaysToDateKey(weekStartKey, 6);
  return `${formatSastDateKey(weekStartKey)} - ${formatSastDateKey(weekEndKey)}`;
}
